<template>
  <app-content>
    <form action="#">
      <div class="inner">
        <p class="buttons">
          <app-button-delete @click="deleteItem" v-if="!newItem" />
        </p>
        <app-content-title :title="fullName" :sub-title="userPosition" />
      </div>

      <app-settings @submit="submitForm" :disabled="pending">
        <app-settings-content>
          <app-settings-desc :title="translations.basicInfo">
            <p>
              <translate>Založeno</translate>:<br />
              <span v-html="formatDateAdvanced(item._created)" />
            </p>
            <p>
              <translate>Poslední login</translate>:<br />
              <span v-html="formatDateAdvanced(item.lastLogin)" />
            </p>
          </app-settings-desc>

          <app-settings-options>
            <app-settings-col class="field_left">
              <app-input
                  required
                  :error="errors.items.find(el => el.field === 'firstName')"
                  :label="translations.name"
                  v-model="formItem.firstName"
                  name="firstName"
              />
              <app-input
                  required
                  :error="errors.items.find(el => el.field === 'lastName')"
                  :label="translations.lastName"
                  v-model="formItem.lastName"
                  name="lastName"
              />
              <app-input
                  required
                  :error="errors.items.find(el => el.field === 'position')"
                  :label="translations.position"
                  v-model="formItem.position"
                  name="position"
              />
            </app-settings-col>

            <app-settings-col class="field_right">
              <app-input
                  required
                  :error="errors.items.find(el => el.field === 'email')"
                  :label="translations.email"
                  v-model="formItem.email"
                  name="email"
              />
              <app-input
                  :required="newItem"
                  :error="errors.items.find(el => el.field === 'password')"
                  :label="newItem ? translations.password : translations.changePassword"
                  v-model="formItem.password"
                  type="password"
                  name="password"
              />
              <app-settings-select
                  required
                  :label="translations.role"
                  :error="errors.items.find(el => el.field === 'role')"
              >
                <app-select
                  name="role"
                  :disabled="isSignedUsersProfile"
                  :options="enums.role"
                  v-model="formItem.role"
                />
              </app-settings-select>
            </app-settings-col>

            <app-settings-input
                :error="errors.items.find(el => el.field === 'note')"
                :label="translations.note"
            >
              <app-textarea
                  v-model="formItem.note"
                  name="note"
              />
            </app-settings-input>
          </app-settings-options>
        </app-settings-content>

        <app-settings-buttons :navLinkTitle="translations.list" :nav-link-to="{ name: 'users' }">
          <app-content-save-button :disabled="pending" @click="disallowBack" />
        </app-settings-buttons>
      </app-settings>
    </form>
  </app-content>
</template>

<script>
import { processFormSubmit } from 'utils/form'
import getItemDetailMixin from 'mixins/getItemDetailMixin'
import appTitleMixin from 'mixins/appTitleMixin'
import formatDateMixin from 'mixins/formatDateMixin'

const itemDetailMixin = getItemDetailMixin({
  apiMethodsSuffix: 'User',
  enums: true
})

export default {
  name: 'user',
  mixins: [formatDateMixin, itemDetailMixin, appTitleMixin()],
  computed: {
    translations() {
      return {
        basicInfo: this.$gettext('Základní údaje'),
        name: this.$gettext('Jméno'),
        lastName: this.$gettext('Příjmení'),
        position: this.$gettext('Pozice'),
        email: this.$gettext('Email'),
        password: this.$gettext('Heslo'),
        changePassword: this.$gettext('Změnit heslo'),
        role: this.$gettext('Role'),
        note: this.$gettext('Poznámka'),
        list: this.$gettext('Seznam')
      }
    },
    fullName() {
      const { firstName, lastName } = this.item

      return `${firstName || ''} ${lastName || ''}`
    },
    userPosition() {
      return this.item.position ? `| ${this.item.position}` : ''
    },
    currentTitle() {
      return [
        { name: this.$gettext('Uživatelé'), link: { name: 'users' } },
        this.item.firstName ? this.fullName : this.$gettext('Uživatel')
      ]
    },
    isSignedUsersProfile() {
      return this.$auth.user()._id === this.item._id
    }
  },
  methods: {
    async submitForm(e) {
      this.errors.clear()

      await this.$validator.validateAll()
      if (this.errors.items.length > 0) {
        this.appShowErrors(this.errors.items.map(v => v.msg))
        return
      }

      const formData = processFormSubmit(e)
      let promise

      if (this.newItem) {
        promise = this.createUser({
          data: formData
        })
      } else {
        promise = this.updateUser({
          params: {
            id: this.itemId
          },
          data: formData
        })

        const loggedUser = this.$auth.user()

        if (this.itemId.toString() === loggedUser._id.toString()) {
          const updatedLoggedUser = {
            ...loggedUser,
            ...formData
          }

          delete updatedLoggedUser.password

          this.$auth.user(updatedLoggedUser)
        }
      }

      const response = await promise.catch(err => err.response)

      this.handleResponseIfError(response)

      if (this.backAllowed) {
        this.goBack()
      } else if (response.status === 201) {
        this.goToDetail(response.data.data._id)
      }
    }
  }
}
</script>
